import React from "react";

export function Label({ required, hint, htmlFor, style, children }) {
  return (
    <div style={{ display: "grid", gap: "var(--ruimte-1)" }}>
      <label htmlFor={htmlFor} style={{ font: "var(--text-label)", color: "var(--text-strong)", ...style }}>
        {children}{required ? <span style={{ color: "var(--alarm)", marginLeft: 3 }}>*</span> : null}
      </label>
      {hint ? <span style={{ fontSize: "var(--fs-xs)", color: "var(--text-soft)" }}>{hint}</span> : null}
    </div>
  );
}
